import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractSelect from '../abstract-select/abstract-select';
import BPCListQueryConfig from '@core/interfaces/bpc-list-query-config';
import _, { get } from 'lodash';
import EntityFormProvider from '../../auto-form/entity-form-provider/entity-form-provider';
import ContactSelectInfo from '@contacts/components/select-info/contact-select-info/contact-select-info.vue';
import InvoiceSelectInfo from '@accounting/components/select-info/invoice-select-info/invoice-select-info.vue';
import EnrollmentSelectInfo from '@activities/components/select-info/enrollment-select-info/enrollment-select-info.vue';
import BookingSelectInfo from '@bookings/components/select-info/booking-select-info/booking-select-info.vue';
import BookingEventSelectInfo from '@bookings/components/select-info/booking-event-select-info/booking-event-select-info.vue';
import AuthorizationHelper from '@auth/services/authorization.helper';
import Pluralize from 'pluralize';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const BpcDrawerModal = () => import('@shared/components/modals/drawer-modal/drawer-modal.vue');

const CustomFilterForm = () =>
  import('@tools/components/forms/custom-filter-form/custom-filter-form.vue');
const StdForm = () => import('../../auto-form/std-form/std-form.vue');

const OptionGroupForm = () =>
  import('@core/components/forms/option-group-form/option-group-form.vue');
const OptionGroupTable = () =>
  import('@core/components/tables/option-group-table/option-group-table.vue');

const ContactTable = () => import('@contacts/components/tables/contact-table/contact-table.vue');
const ContactForm = () => import('@contacts/components/forms/contact-form/contact-form.vue');
const ArticleTable = () => import('@accounting/components/tables/article-table/article-table.vue');
const ArticleForm = () => import('@accounting/components/forms/article-form/article-form.vue');
const BookingForm = () => import('@bookings/components/booking-form/booking-form.vue');
const CertificateForm = () =>
  import('@certificates/components/certificate-form/certificate-form.vue');
const CertificateCategoryForm = () =>
  import('@certificates/components/certificate-category-form/certificate-category-form.vue');
const ActivityTable = () =>
  import('@activities/components/tables/activity-table/activity-table.vue');
const ActivityGroupTable = () =>
  import('@activities/components/tables/activity-group-table/activity-group-table.vue');
const ActivitySessionTable = () =>
  import('@activities/components/tables/activity-session-table/activity-session-table.vue');
const OrderTable = () => import('@accounting/components/tables/order-table/order-table.vue');
const InvoiceTable = () => import('@accounting/components/tables/invoice-table/invoice-table.vue');
const PostTable = () => import('@cms/components/tables/post-table/post-table.vue');
const PostCategoryTable = () =>
  import('@cms/components/tables/post-category-table/post-category-table.vue');
const DrawerBookingForm = () =>
  import('@/app/modules/bookings/components/drawer-booking-form/drawer-booking-form.vue');
const SubscriptionCategoryTable = () =>
  import(
    '@subscriptions/components/tables/subscription-category-table/subscription-category-table.vue'
  );
const TemplateTable = () => import('@tools/pages/template-table/template-table.vue');
const CustomFilterTable = () =>
  import('@tools/components/tables/custom-filter-table/custom-filter-table.vue');
const CertificateTable = () =>
  import('@certificates/components/tables/certificate-table/certificate-table.vue');
const CertificateCategoryTable = () =>
  import(
    '@certificates/components/tables/certificate-category-table/certificate-category-table.vue'
  );
const CouponTable = () => import('@accounting/components/tables/coupon-table/coupon-table.vue');
const CouponForm = () => import('@accounting/components/forms/coupon-form/coupon-form.vue');
const BookingTable = () => import('@bookings/components/tables/booking-table/booking-table.vue');
const MandateForm = () => import('@accounting/components/forms/mandate-form/mandate-form.vue');

@Component({
  name: 'bpc-entity-select',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-contact-table': ContactTable,
    'bpc-article-table': ArticleTable,
    'bpc-coupon-table': CouponTable,
    'bpc-order-table': OrderTable,
    'bpc-activity-table': ActivityTable,
    'bpc-activity-group-table': ActivityGroupTable,
    'bpc-activity-session-table': ActivitySessionTable,
    'bpc-invoice-table': InvoiceTable,
    'bpc-contact-form': ContactForm,
    'bpc-article-form': ArticleForm,
    'bpc-coupon-form': CouponForm,
    'bpc-booking-form': BookingForm,
    'bpc-certificate-form': CertificateForm,
    'bpc-certificate-category-form': CertificateCategoryForm,
    'bpc-contact-select-info': ContactSelectInfo,
    'bpc-booking-select-info': BookingSelectInfo,
    'bpc-booking-event-select-info': BookingEventSelectInfo,
    'bpc-invoice-select-info': InvoiceSelectInfo,
    'bpc-enrollment-select-info': EnrollmentSelectInfo,
    'v-select': vSelect,
    'bpc-std-form': StdForm,
    'bpc-drawer-booking-form': DrawerBookingForm,
    'bpc-option-group-table': OptionGroupTable,
    'bpc-option-group-form': OptionGroupForm,
    'bpc-template-table': TemplateTable,
    'bpc-post-table': PostTable,
    'bpc-post-category-table': PostCategoryTable,
    'bpc-subscription-category-table': SubscriptionCategoryTable,
    'bpc-custom-filter-form': CustomFilterForm,
    'bpc-custom-filter-table': CustomFilterTable,
    'bpc-certificate-table': CertificateTable,
    'bpc-certificate-category-table': CertificateCategoryTable,
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-booking-table': BookingTable,
    'bpc-multi-select': MultiSelect,
    'font-awesome-icon': FontAwesomeIcon,
    'bc-mandate-form': MandateForm,
  },
})
export default class EntitySelect extends mixins(AbstractField, AbstractSelect) {
  $refs!: {
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(clearItems?: boolean): void;
      getConfig(): void;
      loading: boolean;
      accumulateItems: boolean;
      items: any[];
      pagination: any;
      queryConfig: BPCListQueryConfig;
    };
    load: any;
    stdForm: InstanceType<any> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(String) readonly selectValue: string;
  @Prop(String) readonly fetchPath: string;
  @Prop(Array) readonly filters: any[];
  @Prop(Boolean) readonly withTableSearch: boolean;
  @Prop(Boolean) readonly withNew: boolean;
  @Prop(Boolean) readonly withInfo: boolean;
  @Prop({ type: String, default: 'modal' }) readonly withInfoAction: string;
  @Prop({ type: String, default: 'table' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop({
    type: Array,
    default() {
      return ['default'];
    },
  })
  readonly selectConfigName: string[];
  @Prop({ type: String, default: 'lg' }) readonly formModalSize: string;
  @Prop({ type: String, default: null }) readonly permissionEntityName: string;
  @Prop({ type: String, default: null }) readonly completeWithExtraData: string;
  @Prop({ type: Boolean, default: false }) readonly onlyLoadOnOpen: boolean;

  @Prop({ type: String, default: null }) readonly displayType: string;
  @Prop({ type: Number, default: 25 }) readonly selectItemsPerPage: number;
  @Prop({ type: Boolean, default: false }) readonly selectSaveModeForBulkEdit: boolean;
  @Prop({ type: Boolean, default: false }) readonly fromFilters: boolean;

  public saveBulkEditOptions = [
    { label: this.$t('contacts.contact_tags.add_to_existing'), value: 'add_to_existing' },
    { label: this.$t('contacts.contact_tags.replace_all_with'), value: 'replace_all_with' },
    { label: this.$t('contacts.contact_tags.clear_field'), value: 'clear_field' },
    { label: this.$t('contacts.contact_tags.find_and_remove'), value: 'find_and_remove' },
  ];
  public selectedOptionForBulkEdit = this.saveBulkEditOptions[1];

  public observer = null;

  public i = 0;
  public entity = null; // For creation in entity Select
  public isSavingForm = false;
  public randomId = '';
  public permissionEntityNameToUse = null;

  public firstTimeOpened = true;
  public dynamicEntity = null;
  public dynamicLabel = null;
  public allowLoadEntitySelect: boolean = false;
  public extendDrawerWidth: boolean = false;

  get selectedEntity() {
    return this.selectEntity ? this.selectEntity : this.dynamicEntity;
  }

  get selectedLabel() {
    return this.dynamicLabel ? this.dynamicLabel : this.selectLabel;
  }

  get items() {
    return this.$refs?.provider?.items;
  }

  constructor() {
    super();
    this.randomId = this.makeId(10);
  }

  mounted() {
    if (this.onlyLoadOnOpen) {
      this.firstTimeOpened = false;
    }
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.permissionEntityNameToUse = this.permissionEntityName;

    if (this.selectEntity == 'invoice') {
      this.$root.$on('calculateTotalAmount', event => {
        this.calculateTotalAmount();
      });
      this.$root.$on('calculateBalance', event => {
        this.calculateBalance();
      });
    }

    if (this.selectEntity === 'access-control-badge') {
      this.$root.$on('new-badge-created-from-subscription', event => {
        this.model = event;
        this.getEntities();
      });
    }
    if (this.selectEntity === 'access-control-badge') {
      this.$root.$on('new-badge-created-from-attendee', event => {
        this.model = event;
        this.getEntities();
      });
    }
    if (this.selectEntity === 'access-control-badge') {
      this.$root.$on('new-badge-created-from-enrollment', event => {
        this.model = event;
        this.getEntities();
      });
    }
    /* this.$root.$on('updateEntitySelectOnLoad', event => {
      this.dynamicEntity = event;
      this.loadDynamicEntities(event);
    }); */
    if (this.orderBy && this.orderDirection) {
      this.$refs.provider.queryConfig.params.orderBy = this.orderBy;
      this.$refs.provider.queryConfig.params.orderDirection = this.orderDirection;
    }
  }

  destroyed() {
    if (this.selectEntity == 'invoice') {
      this.$root.$off('calculateTotalAmount');
      this.$root.$off('calculateBalance');
    }
    if (this.selectEntity == 'access-control-badge') {
      this.$root.$off('new-badge-created-from-subscription');
      this.$root.$off('new-badge-created-from-attendee');
    }
    /* this.$root.$off('updateEntitySelectOnLoad'); */
  }

  async onOpen() {
    if (!this.firstTimeOpened) {
      this.$refs.provider.getConfig();
      this.firstTimeOpened = true;
    }
    if (this.hasNextPage) {
      await this.$nextTick();
      if (this.$refs.load) {
        this.observer.observe(this.$refs.load);
      }
    }
  }
  onClose() {
    this.observer.disconnect();
  }

  hasNextPage() {
    return (
      this.$refs.provider &&
      this.$refs.provider.pagination.last_page > this.$refs.provider.pagination.current_page
    );
  }

  async infiniteScroll(entries: { isIntersecting: boolean; target: any }[]) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        if (!this.$refs.provider.loading) {
          this.$refs.provider.accumulateItems = true;
          this.$refs.provider.pagination.current_page += 1;
        }
      }
    }
  }

  myDropdownShouldOpen({ noDrop, open, mutableLoading }) {
    return noDrop ? false : open;
  }

  async itemsLoaded() {
    if (this.$refs.load) {
      const ul = this.$refs.load.offsetParent;
      const scrollTop = ul.scrollTop;
      await this.$nextTick();
      ul.scrollTop = scrollTop;
    }
    if (this.completeWithExtraData) {
      const id = typeof this.value === 'object' ? _.get(this.value, 'id', {}) : this.value;
      if (this.$refs.provider.items[0].id === id) {
        this.model = this.$refs.provider.items[0];
      } else {
        this.model = null;
      }
    }
    if (this.selectValue != 'id' && typeof this.model == 'number') {
      // If the model is a id and the selectValue is not id, then we assume that the id in the this.model is a provisional id and we have to fill the model with the object with id = this.model
      this.model = this.$refs.provider.items.find(item => item['id'] === this.model);
    }

    if (
      this.selectValue != 'id' &&
      Array.isArray(this.model) &&
      this.model.every(function(element) {
        return typeof element === 'number';
      })
    ) {
      // If the model is an array of ids and the selectValue is not id, then we assume that the ids in the this.model is a provisional id and we have to fill the model with the objects with ids in this.model
      this.model = this.$refs.provider.items.filter(item => this.model.includes(item['id']));
    }

    this.$emit('items-loaded', this.$refs.provider.items);

    if (this.$refs.load) {
      this.observer.disconnect();
      this.observer.observe(this.$refs.load);
    }
  }

  myValue = null;

  extendHandleEvent(eventName: string, event: any, val: any) {
    if (event.filters) {
      event.filters.forEach(filter => {
        if (filter.strictValue) {
          this.$set(this.$refs.provider.queryConfig.params, filter.field, filter.value);
        } else if (!filter.value) {
          this.$set(this.$refs.provider.queryConfig.params, filter.field, val);
        } else {
          this.$set(
            this.$refs.provider.queryConfig.params,
            filter.field,
            get(val, filter.value, val),
          );
        }
      });
    }
    if (event.action === 'getDynamicEntities') {
      this.loadDynamicEntities(val);
    }
    if (event.action === 'getEntities') {
      this.$refs.provider.items = [];
      this.model = null;
      this.$refs.provider.getEntities();
    }
    if (event.action === 'refreshOptions') {
      this.model = null;
    }
    if (event.action === 'setExtraData') {
      this.$set(this.extraData, event.propertyPath, val);
    }
    if (event.action === 'selectEntity') {
      // Only works for single selects (if receive more entities does not take anything)
      const itemIdFromEvent = Array.isArray(val)
        ? val.length === 1
          ? val[0]?.[`${event.entity}_id`]
          : null
        : val?.[`${event.entity}_id`];
      this.model = itemIdFromEvent;
      setTimeout(() => {
        if (this.$refs.provider.pagination.current_page != 1) {
          this.$refs.provider.pagination.current_page = 1;
        }
        this.$refs.provider.getEntities();
      });
    }
    if (event.action === 'selectMultipleEntities') {
      // Only works for single selects (if receive more entities does not take anything)
      this.model = Array.isArray(val)
        ? val.length === 1
          ? val[0]?.[`${event.entity}_ids`]
          : null
        : val?.[`${event.entity}_ids`];
      setTimeout(() => {
        if (this.$refs.provider.pagination.current_page != 1) {
          this.$refs.provider.pagination.current_page = 1;
        }
        this.$refs.provider.getEntities();
      });
    }
  }

  loadDynamicEntities(entity) {
    // Set the formConfigName and all the elements needed to load the entity select properly
    this.dynamicLabel = this.selectDynamicLabel(entity);
    this.dynamicEntity = entity;
    // Do not empty the items if it's the first load of the form and the elements are set
    this.$refs.provider.items = [];
    this.model = null;
    this.$refs.provider.getEntities();
  }

  selectDynamicLabel(entity) {
    switch (entity) {
      case 'discipline':
      case 'resource':
      case 'activity':
        return 'name';
      case 'post':
        return 'title';
      case 'contact':
        return 'code_fullname';
    }
  }

  /** START FUNCT OF SEARCH TABLE */
  get tableComponentName(): string {
    switch (this.selectEntity) {
      case 'contact':
        return 'bpc-contact-table';
      case 'article':
        return 'bpc-article-table';
      case 'coupon':
        return 'bpc-coupon-table';
      case 'order':
        return 'bpc-order-table';
      case 'bpc-activity':
        return 'bpc-activity-table';
      case 'activity-group':
        return 'bpc-activity-group-table';
      case 'activity-session':
        return 'bpc-activity-session-table';
      case 'invoice':
        return 'bpc-invoice-table';
      case 'option-group':
        return 'bpc-option-group-table';
      case 'template':
        return 'bpc-template-table';
      case 'post':
        return 'bpc-post-table';
      case 'post-category':
        return 'bpc-post-category-table';
      case 'subscription-category':
        return 'bpc-subscription-category-table';
      case 'custom-filter':
        return 'bpc-custom-filter-table';
      case 'certificate':
        return 'bpc-certificate-table';
      case 'certificate-category':
        return 'bpc-certificate-category-table';
      case 'booking':
        return 'bpc-booking-table';
      default:
        // return `bpc-${this.fieldConfig.inputType}`;
        return 'bpc-contact-table';
    }
  }

  onSearchButton() {
    this.$bvModal.show(`${this.randomId}-table-search-modal`);
  }

  // function for the selection of a element in the search table
  onSelect($event) {
    this.$bvModal.hide(`${this.randomId}-table-search-modal`);
    this.forceSelectElement($event.item);
  }

  /** END FUNCT OF SEARCH TABLE */

  /** START FUNCT OF CREATION FORM */

  get formComponentName(): string {
    switch (this.selectEntity) {
      case 'contact':
        return 'bpc-contact-form';
      case 'article':
        return 'bpc-article-form';
      case 'coupon':
        return 'bpc-coupon-form';
      case 'booking':
        return 'bpc-booking-form';
      case 'option-group':
        return 'bpc-option-group-form';
      case 'custom-filter':
        return 'bpc-custom-filter-form';
      case 'certificate':
        return 'bpc-certificate-form';
      case 'certificate-category':
        return 'bpc-certificate-category-form';
      case 'mandate':
        return 'bc-mandate-form';
      default:
        return 'bpc-std-form';
    }
  }

  get selectEntityFormConfigName() {
    switch (this.selectEntity) {
      case 'contact':
        return this.entity?.id ? 'edit' : 'default';
      case 'invoice':
        return this.entity?.id ? 'edit-invoice' : 'default';
      default:
        return this.formConfigName;
    }
  }

  get selectEntityPermissionNameToUse() {
    switch (this.selectEntity) {
      case 'contact':
        return 'contacts';
      case 'invoice':
        return 'invoices';
      default:
        return this.permissionEntityNameToUse;
    }
  }

  get selectEntityDrawerSize() {
    switch (this.selectEntity) {
      case 'contact':
        return 'xl';
      case 'template':
        return 'lg';
      case 'post':
        return 'xl';
      default:
        return 'md';
    }
  }

  calculateTotalAmount() {
    const orders = this.$refs.stdForm?.formModel?.orders || [];
    let totalAmount: number = 0;
    orders.forEach(item => (totalAmount += item.total_price));
    this.$set(this.$refs.stdForm.formModel, 'total_amount', Number(totalAmount).toFixed(2));
    this.calculateBalance();
  }

  calculateBalance() {
    console.log(this.$refs.stdForm.formModel);
    const totalAmount = this.$refs.stdForm.formModel.total_amount;
    const paidAmount = this.$refs.stdForm.formModel.paid_amount;
    this.$set(this.$refs.stdForm.formModel, 'balance', (totalAmount - paidAmount).toFixed(2));
  }

  onNewButton() {
    this.entity = null;
    this.showDrawerForm = true;
  }

  onFormSaved($event) {
    this.forceSelectElement($event.data);
    this.isSavingForm = false;
    this.showDrawerForm = false;
  }
  onFormSave() {
    this.isSavingForm = true;
    this.$refs.stdForm.saveEntity();
  }
  onFormClose() {
    this.showDrawerForm = false;
  }

  onFormEdit() {
    // this.disabled = false;
  }

  /** END FUNCT OF CREATION FORM */

  /** START FUNCT OF INFO */
  get infoComponentName(): string {
    switch (this.selectEntity) {
      case 'contact':
        return 'bpc-contact-select-info';
      case 'booking':
        return 'bpc-booking-select-info';
      case 'booking-event':
        return 'bpc-booking-event-select-info';
      case 'invoice':
        return 'bpc-invoice-select-info';
      case 'enrollment':
        return 'bpc-enrollment-select-info';
      default:
        // return `bpc-${this.fieldConfig.inputType}`;
        return;
    }
  }

  showDrawerForm = false;
  onMoreInfo($event) {
    if (this.withInfoAction != 'event') {
      this.entity = $event;
      this.showDrawerForm = true;
    } else {
      this.$root.$emit('contact-more-info', $event);
    }
  }

  /** END FUNCT OF SEARCH TABLE */

  forceSelectElement(selectedItem) {
    if (this.selectMultiple) {
      if (Array.isArray(this.model)) {
        this.model.push(selectedItem);
      } else {
        this.model = [selectedItem];
      }
    } else {
      this.model = selectedItem;
    }

    const search = this.$refs.provider.items.find(item => {
      return item['id'] === selectedItem['id'];
    });
    if (!search) {
      this.$refs.provider.items.push(selectedItem);
    }
  }

  public makeId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  addSelected() {
    const items = this.$refs[this.tableComponentName].selection;

    if (Array.isArray(this.model)) {
      const allSelected = this.model.map(item => item['id']).concat(items);
      const model = [...new Set(allSelected)]; // Unique values
      this.$set(this, 'model', model);
    } else {
      this.model = items;
    }

    this.$nextTick().then(() => {
      this.$refs.provider.getEntities();
    });

    this.$bvModal.hide(`${this.randomId}-table-search-modal`);
  }

  get bookingDrawerTitle(): string {
    return this.$t('global.modals.edit') + ' ' + this.$t('global.models.booking.name');
  }

  deep: number = 0;

  onFormClosed() {
    // this.$bvModal.hide('modal-resource-form');
    // this.$refs.provider.getEntities();
    this.showDrawerForm = false;
  }

  getEntities() {
    this.$refs.provider.getEntities();
  }

  get entityId() {
    return this.entity?.id ? this.entity.id : null;
  }

  get bookingId() {
    return this.selectEntity === 'booking' && this.entityId ? this.entityId : this.makeId(10);
  }

  get drawerBookingStoreName() {
    const initial =
      this.selectEntity === 'booking' && this.entityId ? `booking_${this.entityId}` : 'booking';
    return `${initial}_${this.deep}`;
  }

  get hasCustomOptionSlot(): boolean {
    return !!this.$slots.customOption;
  }

  @Watch('bookingId')
  onChangeBookingId() {
    this.deep++;
  }

  onChange($event) {
    this.$emit('change', $event);
    this.$emit('input-custom-event', { eventName: `${this.name}_changed`, item: $event });
  }

  // @Watch('entity')
  // async onShowChange() {
  //   if (this.selectEntity === 'booking' && this.entity !== null && this.entity.id) {
  //     if (this.drawerStoreName !== 'booking' && !this.$store.hasModule(this.drawerStoreName)) {
  //       console.log('ENTRA EN BEFORE MOUNT A REGISTRAR MODULO');
  //       console.log('registering module', this.drawerStoreName);
  //       const mutations = {...BookingModule.mutations};
  //       const getters = {...BookingModule.getters};
  //       const state = {...BookingModule.state};
  //       const actions = {...BookingModule.actions};
  //
  //       const mod = {
  //         namespaced: true,
  //         state,
  //         actions,
  //         mutations,
  //         getters,
  //       } as Module<BookingFormState, RootState>;
  //
  //       await this.$store.registerModule(this.drawerStoreName, mod);
  //
  //       console.log('module registered', this.drawerStoreName);
  //       console.log('this.$store', this.$store);
  //     }
  //
  //     this.$store.commit(`${this.drawerStoreName}/setMode`, 'api');
  //   }
  // }

  hasPermissionForCreation(): boolean {
    const permissions = [];
    permissions.push(
      {
        name: AuthorizationHelper.getPermissionName(
          'store',
          this.permissionEntityNameToUse
            ? this.permissionEntityNameToUse
            : this.getPlural(this.selectEntity),
        ).replace('-', '_'),
      },
      {
        name: AuthorizationHelper.getPermissionName(
          'store',
          this.permissionEntityNameToUse
            ? this.permissionEntityNameToUse
            : this.getPlural(this.selectEntity),
          true,
        ).replace('-', '_'),
      },
    );
    return this.$authorizationService.hasPermissions(permissions);
  }

  getPlural(str: string): string {
    return Pluralize.isSingular(str) ? Pluralize(str) : str;
  }

  onSelectedApplyBulkEdit(option) {
    this.$root.$emit('selected-apply-bulk-edit', option, this.selectEntity);
  }

  onInputCustomEvent(event) {
    const eventName = event.eventName;
    switch (eventName) {
      case 'open_template_variables':
        this.extendDrawerWidth = true;
        break;
      case 'close_template_variables':
        this.extendDrawerWidth = false;
        break;
      default:
        break;
    }
  }

  onErrorSavingEntity() {
    this.isSavingForm = false;
  }
}
